import { useDeckStore } from '@/store'
import { formatDocForAi } from '@/lib/ai/serializeForAi'
import type { AiSkill } from '@/types'

// Contexte d'un document sérialisé pour le LLM (sans instruction).
// Réutilisé par buildAskPrompt et par les skills contextuels déclenchés
// depuis un viewer. Retourne une chaîne vide si le document est introuvable.
export function buildDocContextPrompt(docId?: string): string {
  if (!docId) return ''

  const store = useDeckStore()
  try {
    const doc = store.getDocumentById(docId)
    return `Document:\n${formatDocForAi(doc, true)}`
  } catch (err) {
    console.warn('[buildDocContextPrompt] document not found:', docId, err)
    return ''
  }
}

export function buildAskPrompt(docId?: string): string {
  const context = buildDocContextPrompt(docId)
  if (!context) {
    return "Aucun document n'est sélectionné. Demande à l'utilisateur l'identifiant du document à rechercher"
  }

  return `${context}\n\nJe veux discuter de ce document. Commence par un résumé factuel en 2 à 3 phrases, puis demande-moi ce que je veux approfondir.`
}

export const dynamicSkillList: AiSkill[] = [
  {
    id: 'analyze-topic',
    labelKey: 'ai.prompts.analyze-topic',
    icon: 'magnifying-glass',
    type: 'general',
    origin: 'dynamic',
    buildContent: (columnId?: string) => {
      if (!columnId) return 'Analyse ce sujet en profondeur.'

      const colInfo = useDeckStore().getColumnById(columnId)
      if (!colInfo) return 'Analyse ce sujet en profondeur.'

      const topic = colInfo.params.query || colInfo.type
      return `Analyse le sujet "${topic}" en profondeur. Utilise \`afp_search_articles\` pour récupérer les dernières dépêches AFP sur ce sujet, puis produis une synthèse complète : contexte, acteurs, faits clés, points de tension. Intègre des liens \`[headline](/doc/UNO)\` pour les articles cités. Ne crée PAS de section "Sources" en fin de réponse.`
    }
  }
]
